module.exports = __webpack_public_path__ + "static/aquipflowservices-logo-a5d2cd2fa058e72711f93e13de8674d6.svg";